import { ReactElement, useContext } from 'react'

import { TabsContext } from '@/lib/core/components/Tabs'

export type TabPanelProps = {
  value: string
  children: (renderProps: { isActive: boolean }) => ReactElement<unknown> | null
}

export const TabPanelComponent = ({ children, value }: TabPanelProps) => {
  const { activeTab } = useContext(TabsContext)

  return children({
    isActive: value === activeTab,
  })
}
